import { paths } from "helpers/paths";
import { deletedFilters } from "helpers/redux";
import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/admin/organizations";
import FeatureModules from "./featureModules";
import Form from "./form";
import List from "./list";
import OdometerHistory from "./odometerHistory";
import Settings from "./settings";
import Show from "./show";

const AdminOrganizations = (props) => {
    useEffect(() => {
        return () => props.clearParams("adminorganizations", deletedFilters());
    }, []);

    const { match, location, history, roles } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    const backToOrganization = (id) => history.push(paths.adminOrganizationsShow(id));
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => <List {...props} isTable transition="full" title="Все организации" nofilter />}
                />
                {(roles.isRoot || roles.isIntegrationManager) && (
                    <Route exact path={`${match.path}/new`} render={() => <Form {...props} back={back} />} />
                )}
                {(roles.isRoot || roles.isIntegrationManager) && (
                    <Route exact path={`${match.path}/settings`} render={() => <Settings {...props} />} />
                )}
                <Route
                    exact
                    path={`${rootUrl}/:id`}
                    render={(rest) => (
                        <Show {...rest} transition="full" title="Организация" back={back} source={source} />
                    )}
                />
                <Route
                    path={paths.adminOrganizationModules(":id")}
                    render={(rest) => (
                        <FeatureModules
                            {...rest}
                            transition="full"
                            title="Модули организации"
                            back={() => backToOrganization(rest.match.params.id)}
                            source={source}
                        />
                    )}
                />
                <Route
                    path={paths.adminOrganizationOdometerHistory(":id")}
                    render={(rest) => (
                        <OdometerHistory
                            {...rest}
                            transition="full"
                            title="История редактирования одометра"
                            back={() => backToOrganization(rest.match.params.id)}
                        />
                    )}
                />
            </Switch>
        </div>
    );
};

export default AdminOrganizations;
